import * as React from "react";
import { SVGProps } from "react";

const Prometeus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 145" {...props}>
    <path
      fill="#020202"
      fillRule="evenodd"
      d="M38.4 145.7h13.8c-12.4-19.9-24.7-39.9-37.1-59.8-1.9-3-2.4-5.8-1-9.4.7-1.7 2.1-3.3 3.4-4.5-.4-.5-.8-1.1-1.2-1.7-2-3.1-3.4-6.5-4.3-10.1C-.5 66.3-3.3 78.6 3.9 90.8l34.5 54.9zm-5.3-43.8c8.1.9 15.6.9 23.6 0 9.8-1.1 18.6-3.4 24-7 5.7-3.7 9.5-9.6 9.5-16.5 0-8-4.9-14.2-11.6-17.8-.6 3-1.6 5.8-2.9 8.3-.7 1.4-1.5 2.7-2.5 3.9 1.5 1.6 2.9 3.6 2.9 5.5 0 3.2-3.6 6.7-6.3 8.2-3.1 1.7-7.6 2.8-11.1 3.2-4.6.5-9.2.7-13.8.8-2.4 0-5-.1-7.4-.3-4.1-.2-8.5-.5-12.5-1.6l8.1 13.3z"
      clipRule="evenodd"
    />
    <path
      fill="#ea7437"
      fillRule="evenodd"
      d="M45.4 0c12.4 20.3 8.1 32.4 6.4 40-2.6 11.8 12.3 15.7 13.4 2 .3-3.2.1-6.9-.1-10.4 15.3 24.6 5.3 46.8-19.7 46.8-21 0-32.8-19.2-24.5-38.3-.9 10.1 6.2 13.4 5 8.7-.3-1.2-.9-3.2-1.4-7.3C22.6 21.9 46.7 16.9 45.4 0z"
      clipRule="evenodd"
    />
  </svg>
);

export default Prometeus;
